"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BenefitPopupScreen;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const PlatformModal_1 = __importDefault(require("../components/PlatformModal"));
const BenefitPopup_1 = __importDefault(require("../partials/BenefitPopup"));
function BenefitPopupScreen(props) {
    const [view, setView] = react_1.default.useState(props.route.params?.view ?? 'detail');
    return ((0, jsx_runtime_1.jsx)(PlatformModal_1.default, { isVisible: true, onDismiss: () => props.navigation.goBack(), children: (0, jsx_runtime_1.jsx)(BenefitPopup_1.default, { data: props.route.params?.data, benefit: props.route.params?.benefit, view: view, navigation: props.navigation, onDismiss: () => props.navigation.goBack(), onViewCard: () => setView('card'), adminView: props.route.params?.adminView, employeeId: props.route.params?.employeeId }) }));
}
